/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interests_Heading_Without_UsernameInputs */

const en_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you want to invest in?`)
};

const de_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In was möchten Sie investieren?`)
};

const pt_br2_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que você quer investir?`)
};

const tr_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelere yatırım yapmak istiyorsunuz?`)
};

const zh_cn2_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您想投资什么？`)
};

const zh_hk2_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您想投資甚麼？`)
};

const ko_kr2_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무엇에 투자하고 싶으신가요?`)
};

const ru_ru2_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Во что вы хотите инвестировать?`)
};

const es_419_onboarding_v1_interests_heading_without_username = /** @type {(inputs: Onboarding_V1_Interests_Heading_Without_UsernameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué quieres invertir?`)
};

/**
* | output |
* | --- |
* | "What do you want to invest in?" |
*
* @param {Onboarding_V1_Interests_Heading_Without_UsernameInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interests_heading_without_username = /** @type {((inputs?: Onboarding_V1_Interests_Heading_Without_UsernameInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interests_Heading_Without_UsernameInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "de") return de_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "tr") return tr_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interests_heading_without_username(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interests_heading_without_username(inputs)
	return es_419_onboarding_v1_interests_heading_without_username(inputs)
});